import { DEFAULT_IMAGE } from '@/utils/const';

import Api from '@/utils/api';

export default {
  props: {
    comment: {
      type: Object,
      default: () => {},
    },
    userId: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      defaultImage: DEFAULT_IMAGE,
      editing: false,

      load: false,
    };
  },
  computed: {
    isAuthor () {
      return this.userId === this.comment.AuthorID;
    },
    checkCommentLength () {
      return this.comment.InnerText.length === 500;
    },
  },
  methods: {
    /**
         * Show modal dialog
         */
    removeCommentHolder () {
      this.$modal.show('dialog', {
        title: 'Are you sure delete this comment?',
        buttons: [{
          title: 'Yes',
          handler: () => {
            this.removeComment();
            this.$modal.hide('dialog');
          },
        }, {
          title: 'No',
        }],
      });
    },

    /**
         * Method for remove current comment
         */
    removeComment () {
      Api.jobs.comments
        .removeComment(this.comment.ID)
        .then((response) => {
          if (response.data.Status) {
            this.$root.$emit('notification', {
              message: 'Comment was delited!',
              type: 'info',
              show: true,
            });

            this.$emit('refreshComment');
          }
        });
    },

    /**
         * Method for change current comment
         */
    changeComment () {
      this.load = true;

      const params = {
        ID: this.comment.ID,
        JobID: this.comment.JobID,
        Innertext: this.comment.InnerText,
      };

      Api.jobs.comments
        .editComment(params)
        .then((response) => {
          if (response.data.Status) {
            this.load = false;
            this.editing = false;

            this.$root.$emit('notification', {
              message: 'Comment was edited!',
              type: 'info',
              show: true,
            });
          } else {
            this.$root.$emit('notification', {
              message: response.data.Message,
              type: 'error',
              show: true,
              listError: response.data.ErrorValues,
            });
          }
        });
    },
  },
};
